module.exports = __webpack_public_path__ + "static/media/license-plate.4b149fac.svg";